// extracted by mini-css-extract-plugin
module.exports = {"editUser":"EditUser_editUser__1kMvG","actionsTitle":"EditUser_actionsTitle__1-ia2"};